import React from 'react';
import Layout from '../../../../components/Layout';
import FeaturedPayPalCancel from './FeaturedPayPalCancel';

const title = 'Pago Cancelado - PayPal';

export default {
  path: '/featured/paypal/cancel',

  async action({ store, query }) {
    const listId = query.listId ? parseInt(query.listId) : null;

    return {
      title,
      component: (
        <Layout>
          <FeaturedPayPalCancel listId={listId} />
        </Layout>
      ),
    };
  },
};
